import { render } from "./MyPatientsListingItem.vue?vue&type=template&id=6c2c27e2"
import script from "./MyPatientsListingItem.vue?vue&type=script&lang=js"
export * from "./MyPatientsListingItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__